import { render, staticRenderFns } from "./copyOrder.vue?vue&type=template&id=20ebaf71&scoped=true"
import script from "./copyOrder.vue?vue&type=script&lang=js"
export * from "./copyOrder.vue?vue&type=script&lang=js"
import style0 from "./copyOrder.vue?vue&type=style&index=0&id=20ebaf71&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ebaf71",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20ebaf71')) {
      api.createRecord('20ebaf71', component.options)
    } else {
      api.reload('20ebaf71', component.options)
    }
    module.hot.accept("./copyOrder.vue?vue&type=template&id=20ebaf71&scoped=true", function () {
      api.rerender('20ebaf71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/order/copyOrder.vue"
export default component.exports